import React, { useEffect, useState } from 'react'
import { configService } from '@/core/services/ConfigService'

interface RuntimeConfigProviderProps {
  children: React.ReactNode
}

interface RuntimeConfigState {
  isLoaded: boolean
  error: string | null
}

export const RuntimeConfigProvider: React.FC<RuntimeConfigProviderProps> = ({ children }) => {
  const [state, setState] = useState<RuntimeConfigState>({
    isLoaded: false,
    error: null,
  })

  useEffect(() => {
    const initializeConfig = async () => {
      try {
        // Wait for runtime configuration to be loaded in production/staging
        await configService.waitForRuntimeConfig()
        setState({ isLoaded: true, error: null })
      } catch (error) {
        console.error('Failed to load runtime configuration:', error)
        setState({ 
          isLoaded: true, // Continue with defaults
          error: error instanceof Error ? error.message : 'Unknown error'
        })
      }
    }

    initializeConfig()
  }, [])

  // Show loading state while waiting for runtime config
  if (!state.isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">
            Carregando configuração...
          </p>
        </div>
      </div>
    )
  }

  // Show error if config failed to load (but continue with app)
  if (state.error) {
    console.warn('Runtime configuration error:', state.error)
  }

  return <>{children}</>
}